import { Card } from "@mui/material";
import { Table as TanStackTable } from "@tanstack/react-table";
import React, { useMemo } from "react";
import { Table, TableSkeleton } from "src/components";
import type { OrganizationReportRow } from "src/models";
import { columnsConfig } from "../utilities";

interface Props {
  isLoading: boolean;
  data: OrganizationReportRow[] | undefined;
}

const OrganizationReportTable = React.forwardRef<TanStackTable<OrganizationReportRow>, Props>((props, ref) => {
  const columns = useMemo(() => columnsConfig(), []);

  return (
    <Card>
      {props.isLoading || props.data === undefined ? (
        <TableSkeleton />
      ) : (
        <Table ref={ref} tableId="organization-report-table" data={props.data} columns={columns} pagination />
      )}
    </Card>
  );
});

export { OrganizationReportTable };
